<template>
  <div class="app-container">
    <el-form
      :model="searchData"
      :inline="true"
      label-position="right"
      ref="searchData"
    >
      <el-form-item label="承运商区域(省)" prop="provinceCode">
        <el-select
          v-model="searchData.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商区域(市)" prop="cityCode">
        <el-select
          v-model="searchData.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!searchData.provinceCode"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否分配承运商" prop="isAllocate">
        <el-select
          v-model="searchData.isAllocate"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in isAllocateOption"
            :key="item.key"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商名称" prop="partnerName">
        <el-input
          v-model="searchData.partnerName"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="组织编号" prop="partnershipId">
        <el-input
          v-model="searchData.partnershipId"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="batchDispatchMasterFun"
          >批量分配承运商</el-button
        >
        <el-button
          type="primary"
          size="medium"
          @click="exportBtnFun"
          :loading="exportFlag"
          >导出</el-button
        >
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()"
          >查询</el-button
        >
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table
      ref="checktableData"
      :data="tableData"
      v-loading="tableLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column label="操作" prop="action" width="120">
        <template slot-scope="scope">
          <el-link type="primary" @click="dispatchRowFun(scope.row)"
            >分配</el-link
          >
        </template>
      </el-table-column>
      <el-table-column
        label="承运区域（省）"
        prop="province"
        min-width="140"
      ></el-table-column>
      <el-table-column
        label="承运区域（市）"
        prop="city"
        min-width="140"
      ></el-table-column>
      <el-table-column label="是否分配承运商" prop="isAllocate" min-width="140">
        <template slot-scope="scope">
          {{ scope.row.isAllocate == 1 ? "已分配" : "未分配" }}
        </template>
      </el-table-column>
      <el-table-column
        label="承运商名称"
        prop="partnerName"
        min-width="140"
      ></el-table-column>
      <el-table-column
        label="组织编号"
        prop="partnershipId"
        min-width="120"
      ></el-table-column>
      <el-table-column
        label="组织类型"
        prop="partnershipTypeDesc"
        min-width="140"
      ></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="pagination.currPage"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <CarrierDialog
      ref="carrierDialogRef"
      @dispatch-success="handleSearch"
    ></CarrierDialog>

    <commonBath
      ref="batchCommonRef"
      @opera-success="handleSearch"
      :errUrl="
        '/autoapp-default-server-recovery/api/business/partnerManagementBond/downLoadJdPartnerAllocateFailInfo'
      "
      :downloadTemplateUrl="
        '/autoapp-default-server-recovery/api/business/partnerManagementBond/exportJdPartnerAllocateRegion'
      "
      :importUrl="
        '/autoapp-default-server-recovery/api/business/partnerManagementBond/importJdPartnerAllocateRegion'
      "
      :title="'批量添加商用承运商区域分配'"
      :uploadTitle="'导入商用承运商区域'"
    ></commonBath>
  </div>
</template>
<script>
import CarrierDialog from "./components/CarrierDialog.vue";
import commonBath from "@/views/oldForNewService/components/commonBath.vue";
import { findAllProvince, findAllCity } from "@/api/oldForNew";

export default {
  components: {
    CarrierDialog,
    commonBath
  },

  data() {
    return {
      searchData: {
        provinceCode: undefined,
        cityCode: undefined,
        isAllocate: undefined,
        carryName: undefined,
        partnershipId: undefined
      },
      provinceList: [],
      cityList: [],
      isAllocateOption: [
        {
          label: "已分配",
          value: 1
        },
        {
          label: "未分配",
          value: 0
        }
      ],
      tableData: [],
      tableLoading: false,
      pagination: {
        currPage: 1,
        pageSize: 10
      },
      total: 0,
      exportFlag: false
    };
  },
  created() {
    this.getTblProvince();
    this.handleSearch();
  },

  methods: {
    //获取省份列表
    async getTblProvince() {
      this.searchData.cityCode = "";
      let { statusCode, data } = await findAllProvince();
      if (statusCode === 200) {
        this.provinceList = data;
      }
    },
    //根据省份获取城市列表
    async getTblCity() {
      this.searchData.cityCode = "";
      if (!this.searchData.provinceCode) {
        return;
      }
      let { statusCode, data } = await findAllCity(
        this.searchData.provinceCode
      );
      if (statusCode === 200) {
        this.cityList = data;
      }
    },
    //根据省市获取区域列表
    getTblCounty() {
      this.search.county = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-county/getTblCounty?city=${this.search.city}`
      ).then(res => {
        if (res.statusCode === 200) {
          this.countyList = res.data;
        }
      });
    },
    // 查询
    handleSearch() {
      this.pagination.currPage = 1;
      this.getList();
    },
    // 清空
    resetForm() {
      this.searchData = {
        provinceCode: undefined,
        cityCode: undefined,
        isAllocate: undefined,
        carryName: undefined,
        partnershipId: undefined
      };
    },
    // 分配
    dispatchRowFun(rowData) {
      this.$refs.carrierDialogRef.opendDialog("dispatch", rowData);
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.currPage = 1;
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    getList() {
      const url =
        "/autoapp-default-server-recovery/api/business/partnerManagementBond/pageJdPartnerRegionAllocate";
      const params = {
        ...this.searchData,
        ...this.pagination
      };
      this.HttpService.post(url, params).then(res => {
        if (res.statusCode === 200) {
          this.tableData = res.data || [];
          this.total = res.total || 0;
        } else {
          const msgTip = res.message || "请求出错";
          this.$message.error(msgTip);
        }
      });
    },
    // 批量
    batchDispatchMasterFun() {
      this.$refs.batchCommonRef.openDialog();
    },
    // 导出

    exportBtnFun() {
      this.exportFlag = true;
      const url =
        "/autoapp-default-server-recovery/api/business/partnerManagementBond/exportJdPartnerAllocateRegion";
      const title = "承运商分配列表导出";
      const params = {
        ...this.searchData,
        ...this.pagination
      };
      this.global.exportExcel(url, params, title)
        .then(() => {
          // 导出成功后处理逻辑
        })
        .catch(res => {
          let blob = new Blob([res.response.data], {
            type: "application/json"
          });
          var blobReader = new Response(blob).json();
          blobReader.then(res => {
            this.$message.error(res.message);
          });
        })
        .finally(() => {
          this.exportFlag = false; // 无论成功或失败都重置 loading 状态
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
.row-bg {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/COldForNewService/carrierArea.vue